module.exports = __webpack_public_path__ + "static/media/delete-location.f409d259.svg";